var render = function render(){
  var _vm$voyageMatrix$acti, _vm$voyageMatrix$acti2, _vm$voyageMatrix$proj;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('tab-nav', {
    staticClass: "iq-edit-profile d-flex",
    attrs: {
      "pills": true
    }
  }, [_c('tab-nav-items', {
    staticClass: "col-md-6 p-0",
    attrs: {
      "active": true,
      "href": "#operational_tab",
      "title": "".concat(_vm.fleet.name, " - OPERATIONAL HISTORY")
    }
  }), _c('tab-nav-items', {
    staticClass: "col-md-6 p-0",
    attrs: {
      "active": false,
      "href": "#scl_tab",
      "title": "".concat(_vm.fleet.name, " - SCL (SOUNDING CHECK LIST)")
    }
  })], 1)], 1), _c('div', {
    staticClass: "tab-content mt-3",
    attrs: {
      "id": "pills-tabContent-2"
    }
  }, [_c('tab-content-item', {
    attrs: {
      "active": true,
      "id": "operational_tab"
    }
  }, [_c('b-row', {
    staticClass: "m-0"
  }, [_c('b-col', {
    staticClass: "m-0 p-0",
    attrs: {
      "md": "12"
    }
  }, [_c('CustomNav', {
    attrs: {
      "items": _vm.voyageTabOpt
    },
    on: {
      "item-click": function itemClick(val) {
        return _vm.voyageTab = val;
      }
    }
  }), _c('div', {
    staticClass: "d-flex justify-content-end mt-3"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard.operational-input',
        query: {
          vehicleId: _vm.$route.query.vehicleId
        }
      }
    }
  }, [_vm.opsOperationalPermissions.add && _vm.opsOperationalPermissions.add === true && !_vm.isChildComponent ? _c('button', {
    staticClass: "btn btn-primary mb-3"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Operational Data")]) : _vm._e()])], 1)], 1), _c('b-col', {
    staticClass: "p-0 m-0",
    attrs: {
      "md": "12"
    }
  }, [_vm.voyageTab == 'monthly' ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("OPERATIONAL HISTORY - " + _vm._s(_vm.fleet.name))])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$checkedHistory, _vm$checkedHistory2, _vm$voyageHistories;
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-row', [_c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker w-100",
          attrs: {
            "type": "datetime",
            "range": "",
            "placeholder": "Select range",
            "format": "DD-MM-YYYY HH:mm"
          },
          model: {
            value: _vm.historiesParamsDate,
            callback: function callback($$v) {
              _vm.historiesParamsDate = $$v;
            },
            expression: "historiesParamsDate"
          }
        })], 1), _c('b-col', {
          staticClass: "px-0",
          attrs: {
            "md": "2"
          }
        }, [_c('b-button', {
          staticClass: "mb-3 text-nowrap",
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              return _vm.onFilterMonthly();
            }
          }
        }, [_vm._v("Apply Filter")])], 1)], 1)], 1), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "md": "6"
          }
        }, [_vm.opsOperationalPermissions.export && _vm.opsOperationalPermissions.export === true ? _c('button', {
          staticClass: "btn btn-dark mb-3 mr-1",
          on: {
            "click": function click($event) {
              return _vm.exportVoyageHistories();
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-file-excel"
        }), _vm._v(" Export ")]) : _vm._e(), _c('b-dropdown', {
          staticClass: "mb-3 p-0 btn",
          attrs: {
            "variant": ((_vm$checkedHistory = _vm.checkedHistory) === null || _vm$checkedHistory === void 0 ? void 0 : _vm$checkedHistory.length) <= 0 ? 'secondary' : 'primary',
            "disabled": ((_vm$checkedHistory2 = _vm.checkedHistory) === null || _vm$checkedHistory2 === void 0 ? void 0 : _vm$checkedHistory2.length) <= 0
          },
          scopedSlots: _vm._u([{
            key: "button-content",
            fn: function fn() {
              return [_c('i', {
                staticClass: "fa fa-id-card"
              }), _vm._v(" Assign to Trip ")];
            },
            proxy: true
          }], null, false, 21358317)
        }, [_c('b-dropdown-item', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.create-new-trip",
            modifiers: {
              "create-new-trip": true
            }
          }],
          attrs: {
            "variant": "dark"
          }
        }, [_vm._v("Create New Trip")]), _c('b-dropdown-item', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.assign-trip",
            modifiers: {
              "assign-trip": true
            }
          }],
          attrs: {
            "variant": "dark"
          }
        }, [_vm._v("Assign to Existing Trip")])], 1)], 1), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('hr'), _vm.voyageMatrix.missingDuration ? _c('b-alert', {
          attrs: {
            "show": "",
            "variant": "primary"
          }
        }, [_vm._v(_vm._s(_vm.voyageMatrix.missingDuration) + ", Not yet input")]) : _vm._e(), _vm.loading_voyage_history ? _c('div', {
          staticClass: "text-center my-5"
        }, [_c('b-spinner', {
          attrs: {
            "type": "grow",
            "label": "Spinning"
          }
        })], 1) : [((_vm$voyageHistories = _vm.voyageHistories) === null || _vm$voyageHistories === void 0 ? void 0 : _vm$voyageHistories.length) > 0 ? [_c('div', {
          staticClass: "overflow-auto tableFixHead",
          staticStyle: {
            "max-height": "600px"
          }
        }, [_c('table', {
          staticClass: "table mb-0 table-striped table-hover"
        }, [_c('thead', {
          staticClass: "thead-dark text-center",
          staticStyle: {
            "z-index": "50",
            "position": "relative"
          }
        }, [_c('tr', [_c('th', {
          staticClass: "text-center"
        }, [_c('b-form-checkbox', {
          attrs: {
            "name": "checkedAll",
            "checked": _vm.isAllChecked
          },
          on: {
            "change": _vm.onCheckedAllHistory
          }
        })], 1), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("No")]), _c('th', {
          staticClass: "text-truncate",
          staticStyle: {
            "width": "200px"
          }
        }, [_vm._v("Type Voyage")]), _c('th', {
          staticClass: "text-center text-truncate"
        }, [_vm._v("Trip Info")]), _c('th', {
          staticClass: "text-center text-truncate"
        }, [_vm._v("Status")]), _c('th', {
          staticClass: "text-center text-truncate"
        }, [_vm._v("Start Trip")]), _c('th', {
          staticClass: "text-center text-truncate"
        }, [_vm._v("End Trip")]), _c('th', {
          staticClass: "text-center text-truncate"
        }, [_vm._v("Project")]), _c('th', {
          staticClass: "text-center text-truncate"
        }, [_vm._v("Start Date")]), _c('th', {
          staticClass: "text-center text-truncate"
        }, [_vm._v("End Date")]), _c('th', {
          staticClass: "text-center text-truncate"
        }, [_vm._v("Reason")]), _c('th', {
          staticClass: "text-center text-truncate"
        }, [_vm._v("Hours")]), _c('th', {
          staticClass: "text-center text-truncate"
        }, [_vm._v("Cargo Loading")]), _c('th', {
          staticClass: "text-center text-truncate"
        }, [_vm._v("Cargo Unloading")]), _c('th', {
          staticClass: "text-center text-truncate"
        }, [_vm._v("Current Position")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Remarks")]), (_vm.opsOperationalPermissions.delete === true || _vm.opsOperationalPermissions.update === true) && !_vm.isChildComponent ? _c('th', [_vm._v("Actions")]) : _vm._e()])]), _c('tbody', _vm._l(_vm.voyageHistories, function (item, index) {
          var _item$subProject, _item$subProject$proj, _item$subProject2, _item$reason;
          return _c('tr', {
            key: "h-".concat(index),
            staticStyle: {
              "font-size": "10pt"
            }
          }, [_c('td', {
            staticClass: "text-center"
          }, [!item.activityType && !item.tripId || item.activityType === 'trip' && !item.tripId ? _c('b-form-checkbox', {
            attrs: {
              "checked": _vm.isChecked(item)
            },
            on: {
              "change": function change($event) {
                return _vm.onCheckedHistory(item);
              }
            }
          }) : _vm._e()], 1), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(index += 1))]), _c('td', {
            staticClass: "text-truncate"
          }, [_c('div', {
            staticClass: "d-flex flex-column"
          }, [_vm._l(item === null || item === void 0 ? void 0 : item.vehicle, function (v, v_index) {
            return _c('span', {
              key: "h-v-".concat(v_index),
              staticClass: "fs-5 mb-1"
            }, [v.id != _vm.vehicleId ? _c('b-badge', {
              attrs: {
                "variant": "success"
              }
            }, [_vm._v(_vm._s(v.name))]) : _vm._e()], 1);
          }), _c('b-badge', {
            staticClass: "mb-1",
            attrs: {
              "variant": "primary"
            }
          }, [_vm._v(_vm._s(_vm.formatString(item === null || item === void 0 ? void 0 : item.voyageType)))]), _vm.isBreakdown(item) ? _c('b-badge', {
            attrs: {
              "variant": "danger"
            }
          }, [_vm._v("Breakdown")]) : _vm._e()], 2)]), _c('td', {
            staticClass: "text-truncate"
          }, [item !== null && item !== void 0 && item.tripId && (item === null || item === void 0 ? void 0 : item.activityType) === 'trip' ? _c('div', {
            staticClass: "d-flex flex-column"
          }, [_c('div', {
            staticClass: "d-flex align-items-center text-primary"
          }, [_c('i', {
            staticClass: "fas fa-map-pin mr-2"
          }), _vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : item.polTrip) + " ")]), _c('div', {
            staticClass: "dashed-border"
          }), _c('div', {
            staticClass: "d-flex align-items-center text-primary"
          }, [_c('i', {
            staticClass: "fa fa-map-pin mr-2"
          }), _vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : item.podTrip) + " ")])]) : _vm._e(), !(item !== null && item !== void 0 && item.tripId) && (item === null || item === void 0 ? void 0 : item.activityType) === 'trip' ? _c('div', {
            staticClass: "d-flex align-items-center text-danger"
          }, [_c('i', {
            staticClass: "ri-close-circle-line mr-2"
          }), _vm._v(" Not Setup Trip ")]) : _vm._e(), (item === null || item === void 0 ? void 0 : item.activityType) === 'non trip' ? _c('div', {
            staticClass: "d-flex align-items-center text-danger"
          }, [_c('i', {
            staticClass: "ri-close-circle-line mr-2"
          }), _vm._v(" Non Trip ")]) : _vm._e(), !(item !== null && item !== void 0 && item.activityType) ? _c('div', {
            staticClass: "d-flex align-items-center text-danger"
          }, [_c('i', {
            staticClass: "ri-close-circle-line mr-2"
          }), _vm._v(" Not Available ")]) : _vm._e()]), _c('td', [!(item !== null && item !== void 0 && item.tripId) ? _c('span', [_vm._v("-")]) : _vm._e(), item !== null && item !== void 0 && item.tripId && !(item !== null && item !== void 0 && item.endTrip) ? _c('b-badge', {
            class: "text-xl text-uppercase mr-2",
            attrs: {
              "variant": "warning"
            }
          }, [_vm._v("Progress")]) : _vm._e(), item !== null && item !== void 0 && item.tripId && item !== null && item !== void 0 && item.endTrip ? _c('b-badge', {
            class: "text-xl text-uppercase mr-2",
            attrs: {
              "variant": "success"
            }
          }, [_vm._v("Finished")]) : _vm._e()], 1), _c('td', {
            staticClass: "text-center text-truncate"
          }, [_vm._v(" " + _vm._s(item !== null && item !== void 0 && item.startTrip ? _vm.moment(item === null || item === void 0 ? void 0 : item.startTrip, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-center text-truncate"
          }, [_vm._v(" " + _vm._s(item !== null && item !== void 0 && item.endTrip ? _vm.moment(item === null || item === void 0 ? void 0 : item.endTrip, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-center"
          }, [_c('p', {
            staticClass: "mb-0 text-truncate"
          }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$subProject = item.subProject) === null || _item$subProject === void 0 ? void 0 : (_item$subProject$proj = _item$subProject.project) === null || _item$subProject$proj === void 0 ? void 0 : _item$subProject$proj.projectName) + " - " + _vm._s(item === null || item === void 0 ? void 0 : (_item$subProject2 = item.subProject) === null || _item$subProject2 === void 0 ? void 0 : _item$subProject2.name) + " ")])]), _c('td', {
            staticClass: "text-center text-truncate"
          }, [_vm._v(" " + _vm._s(item !== null && item !== void 0 && item.startDate ? _vm.moment(item === null || item === void 0 ? void 0 : item.startDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-center text-truncate"
          }, [_vm._v(" " + _vm._s(item !== null && item !== void 0 && item.endDate ? _vm.moment(item === null || item === void 0 ? void 0 : item.endDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-center text-truncate"
          }, [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$reason = item.reason) === null || _item$reason === void 0 ? void 0 : _item$reason.name))]), _c('td', {
            staticClass: "text-center text-truncate"
          }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : item.activityDurationFormat) + " ")]), _c('td', {
            staticClass: "text-center text-truncate"
          }, [_vm._v(_vm._s(item !== null && item !== void 0 && item.cargoLoading ? _vm.numberFormat(item === null || item === void 0 ? void 0 : item.cargoLoading) : '-'))]), _c('td', {
            staticClass: "text-center text-truncate"
          }, [_vm._v(_vm._s(item !== null && item !== void 0 && item.cargoUnloading ? _vm.numberFormat(item === null || item === void 0 ? void 0 : item.cargoUnloading) : '-'))]), _c('td', {
            staticClass: "text-center text-truncate"
          }, [_c('div', {
            staticClass: "d-flex flex-column"
          }, [(item === null || item === void 0 ? void 0 : item.currentPosition) === 'Other' ? _c('strong', {
            staticClass: "mb-0"
          }, [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : item.currentPositionOther))]) : _c('strong', {
            staticClass: "mb-0"
          }, [_vm._v(_vm._s((item === null || item === void 0 ? void 0 : item.currentPosition) || '-'))])])]), _c('td', {
            staticClass: "text-wrap",
            staticStyle: {
              "min-width": "350px"
            }
          }, [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : item.remark))]), (_vm.opsOperationalPermissions.delete === true || _vm.opsOperationalPermissions.update === true) && !_vm.isChildComponent ? _c('td', {
            staticClass: "column-action"
          }, [_c('b-dropdown', {
            attrs: {
              "size": "sm",
              "variant": "dark",
              "toggle-class": "text-decoration-none",
              "text": "Actions",
              "dropright": "",
              "no-caret": ""
            },
            scopedSlots: _vm._u([{
              key: "button-content",
              fn: function fn() {
                return [_vm._v(" Actions "), _c('i', {
                  staticClass: "fa fa-chevron-down ml-1"
                })];
              },
              proxy: true
            }], null, true)
          }, [_vm.opsOperationalPermissions.update === true ? _c('b-dropdown-item', {
            attrs: {
              "variant": "primary"
            },
            on: {
              "click": function click($event) {
                return _vm.toEditHistory(item === null || item === void 0 ? void 0 : item.id);
              }
            }
          }, [_vm._v(" Update Activity ")]) : _vm._e(), _vm.opsOperationalPermissions.update === true && item.tripId ? _c('b-dropdown-item', {
            directives: [{
              name: "b-toggle",
              rawName: "v-b-toggle.swap-trip",
              modifiers: {
                "swap-trip": true
              }
            }],
            attrs: {
              "variant": "warning"
            },
            on: {
              "click": function click($event) {
                _vm.activityTrip = item;
              }
            }
          }, [_vm._v(" Swap Trip ")]) : _vm._e(), _c('b-dropdown-divider'), _vm.opsOperationalPermissions.delete === true ? _c('b-dropdown-item', {
            attrs: {
              "variant": "danger"
            },
            on: {
              "click": function click($event) {
                return _vm.onDeleteActivity(item);
              }
            }
          }, [_vm._v(" Delete Activity ")]) : _vm._e()], 1)], 1) : _vm._e()]);
        }), 0)])])] : _c('p', {
          staticClass: "text-center my-4"
        }, [_vm._v(" No voyage histories data found. ")])]], 2)], 1)];
      },
      proxy: true
    }], null, false, 676916866)
  })], 1), _vm.voyageMatrix && _vm.voyageMatrix.activities && ((_vm$voyageMatrix$acti = _vm.voyageMatrix.activities) === null || _vm$voyageMatrix$acti === void 0 ? void 0 : _vm$voyageMatrix$acti.length) > 0 ? _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("OPERATIONAL MATRIX - " + _vm._s(_vm.fleet.name))])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$voyageHistories2;
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('div', {
          staticClass: "table-responsive"
        }, [_c('table', {
          staticClass: "table mb-0 table-striped table-hover",
          staticStyle: {
            "width": "2200px"
          }
        }, [_c('thead', {
          staticClass: "text-center"
        }, [_c('tr', [_c('th', [_vm._v("No")]), _c('th', [_vm._v("Date")]), _vm._l(_vm.voyageMatrix.activities, function (reason, index) {
          return _c('th', {
            key: index,
            staticClass: "text-truncate"
          }, [_vm._v(_vm._s(reason.name))]);
        })], 2)]), _c('tbody', [((_vm$voyageHistories2 = _vm.voyageHistories) === null || _vm$voyageHistories2 === void 0 ? void 0 : _vm$voyageHistories2.length) > 0 ? _c('tr', [_c('td', {
          staticClass: "text-center"
        }, [_vm._v("1")]), _c('td', {
          staticClass: "text-center text-truncate"
        }, [_vm._v(_vm._s(_vm.voyageMatrix.startDate ? _vm.formatDate(_vm.voyageMatrix.startDate) : '') + " - " + _vm._s(_vm.voyageMatrix.endDate ? _vm.formatDate(_vm.voyageMatrix.endDate) : ''))]), _vm._l(_vm.voyageMatrix.activities, function (value, indexValue) {
          return _c('td', {
            key: indexValue,
            staticClass: "text-center text-truncate"
          }, [_vm._v(_vm._s(value.durationFormat))]);
        })], 2) : _vm._e()])])])])], 1)];
      },
      proxy: true
    }], null, false, 553687266)
  })], 1) : _vm._e(), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        var _vm$fleet;
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("OPERATIONAL MATRIX BY SYSTEM - " + _vm._s((_vm$fleet = _vm.fleet) === null || _vm$fleet === void 0 ? void 0 : _vm$fleet.name))])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$listMatrixBySyste;
        return [_c('b-row', [_vm.listMatrixBySystem && ((_vm$listMatrixBySyste = _vm.listMatrixBySystem.activities) === null || _vm$listMatrixBySyste === void 0 ? void 0 : _vm$listMatrixBySyste.length) > 0 ? _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('div', {
          staticClass: "d-flex overflow-auto"
        }, [_c('table', {
          staticClass: "table mb-0 table-striped table-hover"
        }, [_c('thead', {
          staticClass: "text-center"
        }, [_c('tr', [_c('th', [_vm._v("No")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Date")]), _vm._l(_vm.listMatrixBySystem.activities, function (reason, index) {
          return _c('th', {
            key: index,
            staticClass: "text-center text-truncate"
          }, [_vm._v(_vm._s(reason.name))]);
        })], 2)]), _c('tbody', [_c('tr', [_c('th', [_vm._v("1")]), _c('td', {
          staticClass: "text-center text-truncate"
        }, [_vm._v(_vm._s(_vm.listMatrixBySystem.startDate ? _vm.formatDate(_vm.listMatrixBySystem.startDate) : '') + " - " + _vm._s(_vm.listMatrixBySystem.endDate ? _vm.formatDate(_vm.voyageMatrix.endDate) : ''))]), _vm._l(_vm.listMatrixBySystem.activities, function (value, indexValue) {
          return _c('td', {
            key: indexValue,
            staticClass: "text-center text-truncate"
          }, [_vm._v(_vm._s(value.durationFormat))]);
        })], 2)])])])]) : _c('b-col', {
          staticClass: "align-center text-center",
          attrs: {
            "md": "12"
          }
        }, [_c('strong', {
          staticClass: "text-center text-muted"
        }, [_vm._v("No Data.")])])], 1)];
      },
      proxy: true
    }], null, false, 2192460993)
  })], 1), _vm.voyageMatrix.activities && ((_vm$voyageMatrix$acti2 = _vm.voyageMatrix.activities) === null || _vm$voyageMatrix$acti2 === void 0 ? void 0 : _vm$voyageMatrix$acti2.length) > 0 ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('iq-card', {
    attrs: {
      "class-name": "iq-card-block iq-card-stretch iq-card-height pb-4",
      "body-class": ""
    },
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("OPERATIONAL STATISTIC")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$voyageHistories3;
        return [!_vm.isLoadChart ? _c('b-row', [_c('b-col', [_c('div', {
          staticClass: "text-center"
        }, [_c('b-spinner', {
          attrs: {
            "label": "Spinning"
          }
        })], 1)])], 1) : _vm._e(), _vm.isLoadChart && ((_vm$voyageHistories3 = _vm.voyageHistories) === null || _vm$voyageHistories3 === void 0 ? void 0 : _vm$voyageHistories3.length) > 0 ? _c('b-row', _vm._l(_vm.opsChart, function (item, index) {
          return _c('b-col', {
            key: index,
            attrs: {
              "md": "12"
            }
          }, [(item === null || item === void 0 ? void 0 : item.type) === 'pie' ? _c('div', {
            staticClass: "mb-2"
          }, [_c('b-form-group', {
            attrs: {
              "label": 'Filter Chart '
            }
          }, [_c('v-multiselect', {
            attrs: {
              "tag-placeholder": "Category",
              "placeholder": "Search or statistic",
              "label": "name",
              "track-by": "name",
              "options": _vm.filterFields,
              "multiple": true,
              "taggable": true
            },
            model: {
              value: item === null || item === void 0 ? void 0 : item.bodyData.data,
              callback: function callback($$v) {
                _vm.$set(item === null || item === void 0 ? void 0 : item.bodyData, "data", $$v);
              },
              expression: "item?.bodyData.data"
            }
          })], 1), _c('AmChart', {
            attrs: {
              "element": "pie-chart-".concat(index, "-"),
              "type": item === null || item === void 0 ? void 0 : item.bodyData.type,
              "option": item === null || item === void 0 ? void 0 : item.bodyData
            }
          })], 1) : _vm._e(), (item === null || item === void 0 ? void 0 : item.type) === 'bar' ? _c('div', {
            staticClass: "mb-2"
          }, [_c('b-form-group', {
            attrs: {
              "label": 'Filter Chart '
            }
          }, [_c('v-multiselect', {
            attrs: {
              "tag-placeholder": "Category",
              "placeholder": "Search or statistic",
              "options": _vm.filterFields.map(function (field) {
                return field.name;
              }),
              "multiple": true,
              "taggable": true
            },
            on: {
              "input": function input($event) {
                return _vm.onChangeChart(index);
              }
            },
            model: {
              value: item === null || item === void 0 ? void 0 : item.bodyData.xaxis.categories,
              callback: function callback($$v) {
                _vm.$set(item === null || item === void 0 ? void 0 : item.bodyData.xaxis, "categories", $$v);
              },
              expression: "item?.bodyData.xaxis.categories"
            }
          })], 1), !(item !== null && item !== void 0 && item.loadingChart) ? _c('ApexChart', {
            attrs: {
              "element": "bar-chart-".concat(index, "-"),
              "chartOption": item === null || item === void 0 ? void 0 : item.bodyData
            }
          }) : _vm._e()], 1) : _vm._e()]);
        }), 1) : _vm._e()];
      },
      proxy: true
    }], null, false, 1617809112)
  })], 1) : _vm._e(), _vm.voyageMatrix.projects && ((_vm$voyageMatrix$proj = _vm.voyageMatrix.projects) === null || _vm$voyageMatrix$proj === void 0 ? void 0 : _vm$voyageMatrix$proj.length) > 0 ? _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('iq-card', {
    attrs: {
      "class-name": "iq-card-block iq-card-stretch",
      "body-class": ""
    },
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("PROJECT & CARGO")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('div', {
          staticClass: "table-responsive"
        }, [_c('table', {
          staticClass: "table mb-0 table-striped table-hover"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center"
        }, [_vm._v("No")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Project")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Trip")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Cargo")])])]), _c('tbody', _vm._l(_vm.voyageMatrix.projects, function (item, index) {
          return _c('tr', {
            key: index
          }, [_c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(index + 1))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : item.name))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(_vm.numberFormat(item === null || item === void 0 ? void 0 : item.trip)))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(_vm.numberFormat(item === null || item === void 0 ? void 0 : item.cargo)))])]);
        }), 0), _c('tfoot', [_c('tr', [_c('td', {
          staticClass: "font-weight-bold text-right",
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v("Total")]), _c('td', {
          staticClass: "font-weight-bold text-center"
        }, [_vm._v(_vm._s(_vm.totalTripMatrixProject))]), _c('td', {
          staticClass: "font-weight-bold text-center"
        }, [_vm._v(_vm._s(_vm.totalCargoMatrixProject))])])])])])];
      },
      proxy: true
    }], null, false, 149705493)
  })], 1) : _vm._e()], 1)], 1) : _c('div', [_c('TabVoyageByTrip', {
    attrs: {
      "fleet": _vm.fleet
    }
  })], 1)])], 1)], 1), _c('tab-content-item', {
    attrs: {
      "active": false,
      "id": "scl_tab"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("STEAMING TIME, SOUNDING CHECK LIST, & SUMMARY")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$sclData, _vm$sclData2;
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "md": "8"
          }
        }, [_c('b-form', {
          staticClass: "row",
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              return _vm.fetchSCL();
            }
          }
        }, [_c('b-col', {
          attrs: {
            "md": "4"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "From",
            "label-for": "from"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "exampleInputmonth",
            "type": "date"
          },
          model: {
            value: _vm.sclDateFilter.startDate,
            callback: function callback($$v) {
              _vm.$set(_vm.sclDateFilter, "startDate", $$v);
            },
            expression: "sclDateFilter.startDate"
          }
        }), _c('small', {
          staticStyle: {
            "float": "right"
          }
        }, [_vm._v("click "), _c('i', {
          staticClass: "fa fa-calendar"
        }), _vm._v(" to show")])], 1)], 1), _c('b-col', {
          attrs: {
            "md": "4"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "To",
            "label-for": "to"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "exampleInputmonth",
            "type": "date"
          },
          model: {
            value: _vm.sclDateFilter.endDate,
            callback: function callback($$v) {
              _vm.$set(_vm.sclDateFilter, "endDate", $$v);
            },
            expression: "sclDateFilter.endDate"
          }
        }), _c('small', {
          staticStyle: {
            "float": "right"
          }
        }, [_vm._v("click "), _c('i', {
          staticClass: "fa fa-calendar"
        }), _vm._v(" to show")])], 1)], 1), _c('b-col', {
          attrs: {
            "md": "4"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Filter",
            "label-for": "filter"
          }
        }, [_c('b-button', {
          staticClass: "mb-3 mr-1",
          attrs: {
            "type": "submit",
            "variant": "primary"
          }
        }, [_c('i', {
          staticClass: "fa fa-filter"
        })])], 1)], 1)], 1)], 1), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "md": "4"
          }
        }, [_c('button', {
          staticClass: "btn btn-dark mb-3 mr-1"
        }, [_vm.sclCanExport ? _c('i', {
          staticClass: "fa fa-file-excel"
        }) : _vm._e(), _vm._v(" Export")]), _vm.sclCanAdd ? _c('router-link', {
          attrs: {
            "to": {
              path: '/scl/scl-add',
              query: {
                vehicleId: _vm.$route.query.vehicleId
              }
            }
          }
        }, [_c('button', {
          staticClass: "btn btn-primary mb-3"
        }, [_c('i', {
          staticClass: "fa fa-plus"
        }), _vm._v(" Add SCL")])]) : _vm._e()], 1), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('hr'), _c('div', {
          staticClass: "table-responsive"
        }, [_c('table', {
          staticClass: "table mb-0 table-striped table-hover"
        }, [_c('thead', {
          staticClass: "thead-dark"
        }, [_c('tr', [_c('th', [_vm._v("No")]), _c('th', [_vm._v("Fleet")]), _c('th', [_vm._v("Port of Loading")]), _c('th', [_vm._v("Port of Discharge")]), _c('th', [_vm._v("Cargo Type")]), _c('th', [_vm._v("Quantity")]), _c('th', [_vm._v("Total Steaming Time")]), _vm.sclCanDelete || _vm.sclCanEdit ? _c('th') : _vm._e()])]), _c('tbody', [((_vm$sclData = _vm.sclData) === null || _vm$sclData === void 0 ? void 0 : _vm$sclData.length) > 0 ? _vm._l(_vm.sclData, function (each, i) {
          return _c('tr', {
            key: i
          }, [_c('td', [_vm._v(_vm._s(i += 1))]), _c('td', [_c('router-link', {
            attrs: {
              "to": ""
            }
          }, [_vm._v(_vm._s(each.tugBargeName))])], 1), _c('td', [_vm._v(_vm._s(each.pol))]), _c('td', [_vm._v(_vm._s(each.pod))]), _c('td', [_vm._v(_vm._s(each.cargoType))]), _c('td', [_vm._v(_vm._s(each.quantity) + " MT")]), _c('td', [_c('router-link', {
            attrs: {
              "to": ""
            }
          }, [_vm._v(_vm._s(each.steamingTime))])], 1), _vm.sclCanDelete || _vm.sclCanEdit ? _c('td', [_vm.sclCanEdit ? _c('router-link', {
            attrs: {
              "to": {
                path: '/scl/scl-add',
                query: {
                  vehicleId: _vm.$route.query.vehicleId,
                  scl_id: each.id
                }
              }
            }
          }, [_c('b-button', {
            staticClass: "mr-2",
            attrs: {
              "variant": "success",
              "size": "sm"
            }
          }, [_c('i', {
            staticClass: "fa fa-edit"
          })])], 1) : _vm._e(), _vm.sclCanDelete ? _c('b-button', {
            attrs: {
              "variant": "danger",
              "size": "sm"
            },
            on: {
              "click": function click($event) {
                return _vm.onDeleteSCL(each);
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-trash"
          })]) : _vm._e()], 1) : _vm._e()]);
        }) : _vm._e(), ((_vm$sclData2 = _vm.sclData) === null || _vm$sclData2 === void 0 ? void 0 : _vm$sclData2.length) === 0 ? _c('tr', [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "8"
          }
        }, [_vm._v("No Data")])]) : _vm._e()], 2)])])])], 1)];
      },
      proxy: true
    }])
  })], 1)], 1)], 1), _c('b-sidebar', {
    attrs: {
      "id": "assign-trip",
      "title": "Assign Activity to Trip",
      "width": "100%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    on: {
      "hidden": _vm.closeSidebar
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var hide = _ref.hide;
        return [_c('b-row', {
          staticClass: "m-3"
        }, [_c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('SlideFormAssignTrip', {
          attrs: {
            "checkedHistory": _vm.checkedHistory,
            "closeSidebar": _vm.closeSidebar,
            "unCheckAll": _vm.unCheckAll,
            "refreshData": _vm.refreshData
          }
        })], 1)], 1)];
      }
    }])
  }), _c('b-sidebar', {
    attrs: {
      "id": "create-new-trip",
      "title": "Create and Assign Activity to Trip",
      "width": "100%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    on: {
      "hidden": _vm.closeSidebar
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var hide = _ref2.hide;
        return [_c('b-row', {
          staticClass: "m-3"
        }, [_c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('SlideFormCreateNewTrip', {
          attrs: {
            "checkedHistory": _vm.checkedHistory,
            "closeSidebar": _vm.closeSidebar,
            "unCheckAll": _vm.unCheckAll,
            "refreshData": _vm.refreshData
          }
        })], 1)], 1)];
      }
    }])
  }), _c('b-sidebar', {
    attrs: {
      "id": "swap-trip",
      "title": "Swap Trip",
      "width": "100%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    on: {
      "hidden": _vm.closeSidebar
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var hide = _ref3.hide;
        return [_c('b-row', {
          staticClass: "m-3"
        }, [_c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('SlideFormSwapTrip', {
          attrs: {
            "historiesParamsDate": _vm.historiesParamsDate,
            "activityTrip": _vm.activityTrip,
            "closeSidebar": _vm.closeSidebar,
            "refreshData": _vm.refreshData
          }
        })], 1)], 1)];
      }
    }])
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }